<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="文本最大长度限制" prop="TextBoxMaxLen">
        <el-input-number v-model="value.TextBoxMaxLen" controls-position="right" size="small" :min="0" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="文本最小长度限制" prop="TextBoxMinLen">
        <el-input-number v-model="value.TextBoxMinLen" controls-position="right" :max="value.IsCtrlHidden - 1" size="small" :min="0" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="超出时异常信息" prop="OutRangeInfo">
        <el-input v-model.trim="value.OutRangeInfo" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="默认文本" prop="category">
        <el-input maxlength="50" show-word-limit v-model.trim="value.defaultValue" size="small" />
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: Object,
    },
  };
</script>
